import React from 'react'
import navLogo from '../assets/logo.png';

export const Header = ({handleLogout=()=>{}}) => {
  return (
    <div className='navbar_deisgn'>
        <div className="app-header">
            <div> <img src={navLogo} alt="Dollarbird Logo" className="logo" /></div>
            <div>
              <button className="btn btn-secondary" onClick={handleLogout} title="Log out">Logout</button>
            </div>
        </div>
      </div>
  )
}
